/**
* tabbed slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the tabbed slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import ScrollMagic from 'ScrollMagic';
// import animationGSAP from 'animation.gsap';
// import addIndicators from 'debug.addIndicators';
// import TweenMax from 'TweenMax';
// import TimelineMax from 'TimelineMax';
( function( app ) {
  const COMPONENT = {

    className: 'tabbed-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.tabbed-slider__content-slider' ).slick( {
        focusOnSelect: true,
        arrows: true,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: $( '.tabbed-slider' ).find( '.tabbed-slider__nav-two .tabbed-slider__prev' )[0],
        nextArrow: $( '.tabbed-slider' ).find( '.tabbed-slider__nav-two .tabbed-slider__next' )[0],
        customPaging: function( slider, i ) {
          return $( '.tabbed-slider .tabbed-slider__nav .tabbed-slider__btn-' + i );
        },
        appendDots: '.tabbed-slider__nav',
        dotsClass: 'tabbed-slider__dots',
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'tabbed-slider', COMPONENT );
} )( app );
